import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#1565C0",
        color: "white",
        py: 3,
        px: 2,
        width: '100%',
        mt: 'auto',  
      }}
    >
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} md={6}>
          <Typography variant="h6" fontWeight="bold">
            © {new Date().getFullYear()} IPPIS. All Rights Reserved.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2">
            Contact: {" "}
            <a
              href="mailto:info@ippis.com"
              style={{ color: "white", textDecoration: "underline" }}
            >
              info@mifotra.gov.rw
            </a>{" "}
            | Call us: 9997
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;